<template>
  <v-dialog v-model="dialogComputed" scrollable>
    <v-card>
      <v-card-title class="primary white--text py-2" primary-title>
        {{ inspDataViewOnly ? $t('ELE0152') : $t('ELE0256') }}
        <v-spacer />
        <Btn icon="mdi-close" @click="close" depressed iconProp color="white" />
      </v-card-title>
      <v-card-text>
        <v-container class="px-2 py-2" fluid v-if="isSearched">
          <v-row dense>
            <v-col>
              <InspIndexDetail :indexDetail="indexDetail" />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-card outlined>
                <v-tabs fixed-tabs v-model="tabNo">
                  <v-tab class="ml-0">{{ $t('ELE0211') }}</v-tab>
                  <v-tab>{{ $t('ELE0229') }}</v-tab>
                  <v-tab-item>
                    <v-row v-if="appDataExists">
                      <v-col>
                        <InspDetail :inspDetail="inspAppDetail" />
                      </v-col>
                    </v-row>
                    <v-row v-if="appDataExists">
                      <v-col class="ml-4">
                        <BtnAttach @click="onFileAttachmentBtnClick(enumInspClassCd.APP)" />
                      </v-col>
                    </v-row>
                    <v-row v-if="appDataExists">
                      <v-col class="py-0">
                        <v-card outlined class="px-0 py-0" max-width="800px">
                          <v-card-title class="pt-0">
                            {{ $t('ELE0258') }}
                          </v-card-title>
                          <v-card-text>
                            <v-card outlined>
                              <v-data-table
                                :headers="appInspHeaders"
                                :items="searchAppResult.defects"
                                dense
                                fixed-header
                                disable-pagination
                                hide-default-footer
                                height="200px"
                                mobile-breakpoint="0"
                              >
                                <template v-slot:[`item.defectCd`]="{ item, index }">
                                  <PartDefectInput
                                    :vid="'partDefect_' + index"
                                    v-model="item.defectCd"
                                    :partCd="indexDetail.partCd"
                                    :partRev="searchAppResult.partRev"
                                    disabled
                                  />
                                </template>
                              </v-data-table>
                            </v-card>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item>
                    <v-row v-if="dimDataExists">
                      <v-col>
                        <InspDetail :inspDetail="inspDimDetail" />
                      </v-col>
                    </v-row>
                    <v-row v-if="dimDataExists">
                      <v-col class="ml-4">
                        <BtnAttach @click="onFileAttachmentBtnClick(enumInspClassCd.DIM)" />
                      </v-col>
                    </v-row>
                    <v-row v-if="dimDataExists">
                      <v-col class="py-0">
                        <v-card outlined class="px-0 py-0">
                          <v-card-title class="pt-0">
                            {{ $t('ELE0259') }}
                          </v-card-title>
                          <v-card-text>
                            <v-card outlined>
                              <v-data-table
                                :headers="dimInspHeaders"
                                :items="searchDimResult.characs"
                                dense
                                fixed-header
                                disable-pagination
                                hide-default-footer
                                height="380px"
                                mobile-breakpoint="0"
                              >
                                <template #header>
                                  <thead>
                                    <tr>
                                      <th colspan="6" class="v-data-table__divider"></th>
                                      <th :colspan="drawingStandardColSpan" class="v-data-table__divider normal-cell">
                                        {{ $t('ELE0179') }}
                                      </th>
                                      <th colspan="3" class="v-data-table__divider sa-cell">
                                        {{ $t('ELE0180') }}
                                      </th>
                                      <th colspan="2" class="v-data-table__divider"></th>
                                      <th :colspan="dimInspHeaders.length">{{ $t('ELE0202') }}</th>
                                    </tr>
                                  </thead>
                                </template>
                                <template v-slot:[`item.standard`]="{ item }">
                                  <td class="v-data-table__divider normal-cell">
                                    {{ item.standard }}
                                  </td>
                                </template>
                                <template v-slot:[`item.upper`]="{ item }">
                                  <td class="v-data-table__divider normal-cell">
                                    {{ item.upper }}
                                  </td>
                                </template>
                                <template v-slot:[`item.lower`]="{ item }">
                                  <td class="v-data-table__divider normal-cell">
                                    {{ item.lower }}
                                  </td>
                                </template>
                                <template v-slot:[`item.saStandard`]="{ item }">
                                  <td class="v-data-table__divider sa-cell">
                                    {{ item.saStandard }}
                                  </td>
                                </template>
                                <template v-slot:[`item.saUpper`]="{ item }">
                                  <td class="v-data-table__divider sa-cell">
                                    {{ item.saUpper }}
                                  </td>
                                </template>
                                <template v-slot:[`item.saLower`]="{ item }">
                                  <td class="v-data-table__divider sa-cell">
                                    {{ item.saLower }}
                                  </td>
                                </template>
                                <template v-slot:[`item.measResultCd`]="{ item }">
                                  <td
                                    class="v-data-table__divider"
                                    :style="{ 'background-color': getColorMeasResult(item.measResultCd) }"
                                  >
                                    {{ getInspResultName('MeasResultCd.', item.measResultCd, item.isOutCl) }}
                                  </td>
                                </template>
                              </v-data-table>
                            </v-card>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                </v-tabs>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <div v-if="inspFileAttachDialog">
        <InspectionFileAttachmentDialog
          :dialog.sync="inspFileAttachDialog"
          :headerTitle="$t('ELE0211')"
          :attachedFiles="attachedFilesComputed"
          :isInquiry="true"
          :inspIndexNo="inspIndexNo"
          :cav="cav"
          :numOfInsp="numOfInsp"
        />
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { API } from '@/plugins/api'
import { MeasResultCd, MeasFmtCd, InspClassCd, OqcIqcCd, InspectionTimingDtl } from '@/enum'

import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'
import DateUtil from '@/mixin/date-utils.js'
import StringUtils from '@/mixin/string-utils.js'

import PartDefectInput from '@/components/atoms/select/PartDefectInput'

import Btn from '@/components/atoms/base/button/Btn'
import InspIndexDetail from '@/components/organisms/terminal/card/InspIndexDetail'
import InspDetail from '@/components/organisms/terminal/card/InspDetail'
import TextFieldRef from '@/components/atoms/base/text-field/TextFieldRef'
import BtnAttach from '@/components/atoms/button/BtnAttach.vue'
import InspectionFileAttachmentDialog from '@/components/organisms/terminal/dialog/InspectionFileAttachmentDialog'

export default {
  name: 'ApprovalInspDataDtlDialog',

  mixins: [APIUtils, Message, Loading, DateUtil, StringUtils],
  components: {
    Btn,
    InspIndexDetail,
    InspDetail,
    TextFieldRef,
    PartDefectInput,
    BtnAttach,
    InspectionFileAttachmentDialog,
  },

  props: {
    dialog: {
      type: Boolean,
      required: true,
      default: false,
    },
    inspIndexNo: {
      type: String,
      required: true,
      default: '',
    },
    inspCompanyCd: {
      type: String,
      required: true,
      default: '',
    },
    cav: {
      type: String,
      required: true,
      default: '',
    },
    numOfInsp: {
      type: Number,
      required: true,
      default: 0,
    },
    appDim: {
      type: String,
      required: true,
      default: '',
    },
    inspDataViewOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      isSearched: false,
      appDataExists: false,
      dimDataExists: false,
      tabNo: '',
      indexDetail: null,
      inspAppDetail: null,
      inspDimDetail: {},
      maxNumOfCount: 0,
      searchDimResult: {
        numOfInsp: null,
        inspDate: '',
        inspectorCd: '',
        inspQty: null,
        inspResultCd: '',
        partRev: null,
        inspCharacRev: '',
        remarks: '',
        characs: [],
        isMaxNum: false, // 表示中の検査回数がDB上のMAX値である
        inspTimingDtlCd: '',
      },
      searchAppResult: {
        numOfInsp: null,
        inspDate: '',
        inspectorCd: '',
        inspQty: null,
        inspResultCd: '',
        partRev: null,
        remarks: '',
        defects: [],
        saList: [],
        isMaxNum: false, // 表示中の検査回数がDB上のMAX値である
        inspTimingDtlCd: '',
      },
      inspFileAttachDialog: false,
      attachedFiles: [],
      attachedAppFiles: [],
      attachedDimFiles: [],
      appInspHeaders: [
        {
          text: this.$t('ELE0011'),
          value: 'defectCd',
          divider: true,
          sortable: false,
          cellClass: 'py-1',
          width: '400',
        },
        {
          text: this.$t('ELE0174'),
          value: 'defectQty',
          align: 'right',
          sortable: false,
          cellClass: 'py-1',
          width: '200',
        },
      ],
    }
  },

  computed: {
    enumMeasFmtCd: () => MeasFmtCd,
    enumInspClassCd: () => InspClassCd,
    dialogComputed: {
      get() {
        return this.dialog
      },
      set(value) {
        this.$emit('update:dialog', value)
      },
    },
    dimInspHeaders: {
      get() {
        let result = [
          { text: this.$t('ELE0091'), value: 'inspCharacCd', divider: true, sortable: false, visible: true },
          { text: this.$t('ELE0092'), value: 'inspCharacPoint', divider: true, sortable: false, visible: true },
          { text: this.$t('ELE0181'), value: 'measResultCd', divider: true, sortable: false, visible: true },
          { text: this.$t('ELE0182'), value: 'cp', divider: true, sortable: false, align: 'end', visible: true },
          { text: this.$t('ELE0183'), value: 'cpk', divider: true, sortable: false, align: 'end', visible: true },
          { text: this.$t('ELE0094'), value: 'inspGradeCd', divider: true, sortable: false, visible: true },
          {
            text: this.$t('ELE0095'),
            value: 'standard',
            divider: true,
            sortable: false,
            class: 'normal-cell',
            visible: true,
          },
          {
            text: this.$t('ELE0096'),
            value: 'upper',
            divider: true,
            sortable: false,
            class: 'normal-cell',
            visible: true,
          },
          {
            text: this.$t('ELE0097'),
            value: 'lower',
            divider: true,
            sortable: false,
            class: 'normal-cell',
            visible: true,
          },
          {
            text: this.$t('ELE0538'),
            value: 'clUpper',
            divider: true,
            sortable: false,
            align: 'end',
            class: 'normal-cell',
            cellClass: 'v-data-table__divider normal-cell',
            visible: this.searchDimResult.hasCl ? true : false,
          },
          {
            text: this.$t('ELE0539'),
            value: 'clLower',
            divider: true,
            sortable: false,
            align: 'end',
            class: 'normal-cell',
            cellClass: 'v-data-table__divider normal-cell',
            visible: this.searchDimResult.hasCl ? true : false,
          },
          {
            text: this.$t('ELE0095'),
            value: 'saStandard',
            divider: true,
            sortable: false,
            class: 'sa-cell',
            visible: true,
          },
          {
            text: this.$t('ELE0096'),
            value: 'saUpper',
            divider: true,
            sortable: false,
            class: 'sa-cell',
            visible: true,
          },
          {
            text: this.$t('ELE0097'),
            value: 'saLower',
            divider: true,
            sortable: false,
            class: 'sa-cell',
            visible: true,
          },
          { text: this.$t('ELE0184'), value: 'saNo', divider: true, sortable: false, visible: true },
          { text: this.$t('ELE0025'), value: 'measInstCd', divider: true, sortable: false, visible: true },
        ].filter((header) => header.visible)
        for (let i = 1; i <= this.maxNumOfCount; i++) {
          result.push({
            text: i,
            value: `measValue${i}`,
            divider: true,
            sortable: false,
            align: 'end',
            cellClass: 'py-1',
          })
        }
        return result
      },
    },
    attachedFilesComputed: {
      get() {
        return this.attachedFiles
      },
      set(value) {
        this.attachedFiles = value
      },
    },
    drawingStandardColSpan: {
      get() {
        let result = 3
        if (this.searchDimResult.hasCl) {
          result = 5
        }
        return result
      },
    },
  },

  watch: {
    dialog() {
      if (this.dialog) {
        this.init()
        // タイミングの問題でenumを使用できないので、平文字を使用
        if (this.appDim == InspClassCd.DIM) {
          this.tabNo = 1
        }
      }
    },
  },

  methods: {
    async init() {
      this.startLoading()
      await this.searchInspDim()
      await this.searchInspApp()
      await this.setIndexDetail()
      this.stopLoading()
    },
    close() {
      this.dialogComputed = false
    },
    async searchInspDim() {
      try {
        this.searchDimResult = await API.get('/inspDim', {
          inspIndexNo: this.inspIndexNo,
          cav: this.cav,
          numOfInsp: this.numOfInsp,
        })
        this.maxNumOfCount = this.searchDimResult.maxNumOfMeas
        this.convertMeasValue()
        this.inspDimDetail = {
          inspTimingDtlName: this.searchDimResult['inspTimingDtlName'],
          cav: this.searchDimResult['cav'],
          numOfInsp: this.searchDimResult['numOfInsp'],
          inspQty: this.searchDimResult['inspQty'],
          inspDate: this.searchDimResult['inspDate'],
          inspector: this.searchDimResult['inspectorName'],
          remarks: this.searchDimResult['remarks'],
          inspCompanyCd: this.inspCompanyCd,
        }
        if (this.searchDimResult.dimAttachmentList?.length > 0) {
          this.onSetAttachedFiles(this.searchDimResult.dimAttachmentList, InspClassCd.DIM)
        }
        this.dimDataExists = true
      } catch (error) {
        if (error.response.status != 404) {
          this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0118') })))
        }
      }
    },
    async searchInspApp() {
      try {
        this.searchAppResult = await API.get('/inspApp', {
          inspIndexNo: this.inspIndexNo,
          cav: this.cav,
          numOfInsp: this.numOfInsp,
        })
        this.inspAppDetail = {
          inspTimingDtlName: this.searchAppResult['inspTimingDtlName'],
          cav: this.searchAppResult['cav'],
          numOfInsp: this.searchAppResult['numOfInsp'],
          inspQty: this.searchAppResult['inspQty'],
          inspDate: this.searchAppResult['inspDate'],
          inspector: this.searchAppResult['inspectorName'],
          remarks: this.searchAppResult['remarks'],
          inspCompanyCd: this.inspCompanyCd,
        }
        if (this.searchAppResult.appAttachmentList?.length > 0) {
          this.onSetAttachedFiles(this.searchAppResult.appAttachmentList, InspClassCd.APP)
        }
        this.appDataExists = true
      } catch (error) {
        if (error.response.status != 404) {
          this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0118') })))
        }
      }
    },
    async setIndexDetail() {
      try {
        let partRev = 0
        if (this.searchDimResult.partRev != null) {
          partRev = this.searchDimResult.partRev
        } else if (this.searchAppResult.partRev != null) {
          partRev = partRev > this.searchAppResult.partRev ? partRev : this.searchAppResult.partRev
        }

        let param = {
          partRev: partRev,
        }
        if (this.searchAppResult.inspTimingDtlCd == InspectionTimingDtl.SOURCE) {
          param.filteringInspTimingCd = OqcIqcCd.IQC
        }
        const indexDetail = await API.get('/inspIndex/inspIndexes/' + this.inspIndexNo + '/lot', param)
        indexDetail.saNoList = this.getSaNoList(this.searchDimResult.characs, this.searchAppResult.saList)
        this.indexDetail = indexDetail
        this.isSearched = true
      } catch (error) {
        this.isSearched = false
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0118') })))
      }
    },
    convertMeasValue() {
      // 測定結果を表示しやすいように変換
      for (let idx = 0; idx < this.searchDimResult.characs.length; idx++) {
        const charac = this.searchDimResult.characs[idx]

        for (let num = 1; num <= this.maxNumOfCount; num++) {
          let obj = charac.measValueList.find((m) => m.numOfMeas == num)

          let value = ''
          if (!obj || !obj.measValue) {
            value = ''
          } else if (charac.measFmtCd == MeasFmtCd.OK_NG) {
            value = this.$t(`DimJudgeCd.${obj.measValue}`)
          } else {
            value = obj.measValue
          }
          charac['measValue' + num] = value
        }
      }
    },

    getSaNoList(characs, saList) {
      // SA Noを抽出
      let items = []
      if (characs.length) {
        characs.forEach(function (element) {
          if (element.saNo) {
            items.push(element.saNo)
          }
        })
        items = Array.from(new Set(items))
      }
      if (saList.length) {
        saList.forEach(function (element) {
          items.push(element)
        })
      }
      return items
    },
    getEnumlang(key, value) {
      // langのenumからメッセージ取得
      let lang = ''
      if (value) {
        lang = this.$t(key + value)
      }
      return lang
    },

    getColorMeasResult(measResultCd) {
      // 測定結果に対応する色設定
      let color = ''

      if (measResultCd == MeasResultCd.OK) {
        color = '#EDEFFD'
      } else if (measResultCd == MeasResultCd.SA_OK) {
        color = '#FCF4A1'
      } else if (measResultCd == MeasResultCd.NG) {
        color = '#F8CED2'
      }

      return color
    },
    onSetAttachedFiles(fileList, inspClass) {
      const attachedFiles = fileList.map((element) => {
        if (!element.filename) {
          return {
            ...element,
            filename: element.filePath.split('/').pop(),
          }
        }
        return element
      })
      if (inspClass == InspClassCd.APP) {
        this.attachedAppFiles = attachedFiles
      } else {
        this.attachedDimFiles = attachedFiles
      }
    },
    onFileAttachmentBtnClick(inspClass) {
      if (inspClass == InspClassCd.APP) {
        this.attachedFilesComputed = this.attachedAppFiles
      } else {
        this.attachedFilesComputed = this.attachedDimFiles
      }
      this.inspFileAttachDialog = true
    },
  },
  mounted() {
    this.init()
    // タイミングの問題でenumを使用できないので、平文字を使用
    if (this.appDim == InspClassCd.DIM) {
      this.tabNo = 1
    }
  },
}
</script>
<style>
.normal-cell {
  background-color: #edeffd !important;
  text-align: end !important;
}
.sa-cell {
  background-color: #fcf4a1 !important;
  text-align: end !important;
}
</style>
